// extracted by mini-css-extract-plugin
export default {"grid":"HowItWorksSection_grid__-Q0eU","step":"HowItWorksSection_step__Jtbnt","stepNum":"HowItWorksSection_stepNum__9U-0A"};